<template>
  <home-layout>
    <section class ="center center-blog">
      <div class="row row-cols-1 row-cols-md-3 g-4 mt-5">
        <div v-for="(item, index) in posts" :key="index" class="col-lg-3 col-sm-6 mb-3">
          <div class="card h-100">
              <img :src="item.attributes.featuredImage.data.attributes.url" class="card-img-top" alt="...">
              <div class="card-body">
                  <h5 class="card-title">{{item.attributes.Title}}</h5>
                  <p class="card-text">{{item.attributes.ShortDescription}}</p>
                  <a :href="'/blog/' + item.attributes.slug" class="btn btn-blog">Ver</a>
              </div>
              <div class="card-img-overlay">
                <p class="card-text card-category">{{ item.attributes.category.data.attributes.CategoryName }}</p>
              </div>
          </div>
        </div>
      </div>
    </section>

    <header-info :isBlog=true></header-info>
    <footer-info></footer-info>
  </home-layout>
</template>

<script>

import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import {getPosts} from '@/services/blog'

export default {
  name: 'Blog',
  props: {
  },
  data () {
    return {
      posts:[],
      firsTitle:"",
      firstSubtitle:"",
      firstImage:"",
      firstUrl:"",
      nameCategory:""
    }
  },
  methods: {
    getPosts() {
      getPosts().then((response) => {
        if (response.error) {
          this.showData = false
          this.showError = true
          this.messageErrorLogin = 'Sin Articulos'
  
        } else {
          this.posts = response.data.data
          
        }
     })
    }
  }
  ,
  created () {
    this.getPosts()
  },
  mounted () {
    
  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo
  }
}
</script>
